import { useState } from 'react';
import { GROUP_LABELS, scaleMap, type NutrientDef, type NutrientMap } from '../../shared/nutrients';
import { amount, defFor, unitLabel } from '../lib/format';

interface Props {
  per100: NutrientMap;
  grams: number;
  defs: Map<string, NutrientDef>;
  tracked: string[];
}

/** Every known nutrient for this amount: tracked ones first, the rest behind "More". */
export function NutritionPanel({ per100, grams, defs, tracked }: Props) {
  const [more, setMore] = useState(false);
  const n = scaleMap(per100, grams);
  const keys = Object.keys(n);
  const trackedKeys = tracked.filter((k) => keys.includes(k));
  const others = keys.filter((k) => !tracked.includes(k));
  const missingTracked = tracked.filter((k) => !keys.includes(k));

  const row = (key: string) => {
    const def = defFor(key, defs);
    return (
      <div key={key} className="row between small" style={{ padding: '6px 0', borderBottom: '1px solid var(--line)' }}>
        <span>{def.name}</span>
        <span className="num">
          <b>{amount(n[key], def)}</b> {unitLabel(def)}
        </span>
      </div>
    );
  };

  return (
    <div>
      {trackedKeys.map(row)}
      {missingTracked.length > 0 && (
        <p className="tiny faint" style={{ marginTop: 6 }}>
          No data for {missingTracked.map((k) => defFor(k, defs).name).join(', ')}.
        </p>
      )}
      {others.length > 0 && (
        <>
          <button className="btn btn--quiet btn--xs" style={{ marginTop: 8 }} onClick={() => setMore((m) => !m)} aria-expanded={more}>
            {more ? 'Hide' : `More nutrients (${others.length})`}
          </button>
          {more &&
            Object.entries(GROUP_LABELS).map(([group, label]) => {
              const inGroup = others.filter((k) => defFor(k, defs).group === group);
              if (!inGroup.length) return null;
              return (
                <div key={group} style={{ marginTop: 10 }}>
                  <div className="ngroup__title">{label}</div>
                  {inGroup.map(row)}
                </div>
              );
            })}
        </>
      )}
    </div>
  );
}
